import React, { Fragment, useEffect, useState } from 'react';
import { UpstartIcon } from 'components/Icons/Upstart';
import { DealerWithFlags } from '@upstart/harmony/lib/legos/dealerTypes';
import useLocalStorage from 'util/useLocalStorage';
import { Banner } from '../../components/Banner/Banner';
import './Banners.scss';

const BANNER_DATA_URL =
  'https://production-prodigy-cdn-782149192491-us-east-1.s3.amazonaws.com/dealer-flat-banner.json';

type BannerData = {
  title: string;
  message: {
    submit: string;
    creditApps: string;
    sections: string[];
  };
};

export function SuperFlatBanner({
  dealer,
  userId,
}: {
  dealer: DealerWithFlags;
  userId: number;
}) {
  const [showBanner, setShowBanner] = useLocalStorage(
    `userId:${userId}.showSuperFlatBanner`,
    true,
  );
  const [bannerData, setBannerData] = useState<BannerData | null>(null);
  useEffect(() => {
    const fetchBannerData = () =>
      fetch(BANNER_DATA_URL)
        .then((res) => res.json())
        .then(setBannerData);
    fetchBannerData();
  }, []);
  if (
    !bannerData ||
    !showBanner ||
    !userId ||
    !dealer?.lending?.instore?.enabled ||
    !dealer?.lending?.upstart?.enabled
  ) {
    return null;
  }
  return (
    <div className="superflat-banner-wrapper">
      <Banner
        leftSection={<Banner.Title>{bannerData.title}</Banner.Title>}
        content={
          <div className="superflat-banner-content">
            <span>{bannerData.message.submit}</span>
            <span className="pl-8 pr-8">
              <UpstartIcon size={32} />
            </span>
            <span>{bannerData.message.creditApps}</span>
            {bannerData.message.sections.map((section) => (
              <Fragment key={section}>
                <Banner.VerticalTextSeparator />
                <span>{section}</span>
              </Fragment>
            ))}
          </div>
        }
        rightSection={
          <Banner.DismissButton onClick={() => setShowBanner(false)} />
        }
      />
    </div>
  );
}
